import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export default function Root() {
    const location = useLocation();

    const useContainer = !location.pathname.match(/^\/locations\/[^/]+\/units\/?$/);

    return (
        <>
            {/* <Navbar /> */}
            {/* <JourneyProgress /> */}
            {useContainer ? (
                <div>
                    <Outlet />
                </div>
            ) : (
                <Outlet />
            )}
        </>
    );
}
